import { Delta, Op } from 'quill/core';

const THREAD_ATTRIBUTES = ['comment', 'reaction'];

function getDeltaForRemovingThread(content: Delta, id: string): Delta {
  const change = new Delta();
  content.ops.forEach((op) => {
    THREAD_ATTRIBUTES.forEach((attribute) => {
      const items = op.attributes?.[attribute];
      if (Array.isArray(items) && items.includes(id)) {
        const filtered = items.filter((item) => item !== id);
        change.retain(Op.length(op), {
          [attribute]: filtered.length ? filtered : null,
        });
      }
    });

    if (op.insert && typeof op.insert === 'object') {
      if (op.insert['table-embed']) {
        const cellsChange: Record<string, { content: Op[] }> = {};
        // @ts-expect-error
        const cells = op.insert['table-embed'].cells || {};
        const identities = Object.keys(cells);
        identities.forEach((identity) => {
          const cellContent = cells[identity]?.content;
          if (cellContent) {
            const cellChange = getDeltaForRemovingThread(
              new Delta(cellContent),
              id,
            );
            if (cellChange.length() > 0) {
              cellsChange[identity] = {
                content: cellChange.ops,
              };
            }
          }
        });

        if (Object.keys(cellsChange).length > 0) {
          change.retain({ 'table-embed': { cells: cellsChange } });
          return;
        }
      } else if (op.insert['code-embed']) {
        const codeChange = getDeltaForRemovingThread(
          new Delta(op.insert['code-embed'] as Op[]),
          id,
        );
        if (codeChange.length() > 0) {
          change.retain({ 'code-embed': codeChange.ops });
          return;
        }
      }
    }

    change.retain(Op.length(op));
  });

  return change.chop();
}

export default getDeltaForRemovingThread;
